export default Object.freeze([
  { id: 1, name: 'Impresos' },
  { id: 2, name: 'No Impresos' },
]);
